import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { textInputStyle } from '@/components/ui/Form/TextInput/style';
/**
 * テキストエリア コンポーネント
 * NOTE: デザインシステムのルールに基づいて値を設定をしています
 * WARNING: 設定値の変更, 追加をする場合は、デザインデータの更新必須
 * @param props
 * @returns
 */
export const TextInput = (props) => {
    const { className = '', disabled = false, id = undefined, inputProps = {}, isError = false, name = undefined, onChange = () => { }, placeholder = undefined, readOnly = false, required = false, setRef, value = undefined, } = props;
    const style = textInputStyle({ class: className });
    return (_jsx("input", Object.assign({}, inputProps, { "aria-invalid": isError, className: style, disabled: disabled, id: id, name: name, onChange: onChange, placeholder: placeholder, readOnly: readOnly, ref: setRef, required: required, value: value })));
};
